export default [{
  type: 'tab',
  active: '0',
  items: [{
    title: '属性',
    labelWidth: '100px',
    items: [{
      text: '加密 key',
      name: 'id',
      type: 'display',
    },
    {
      text: '后端活动 ID',
      name: 'backendId',
      type: 'display',
    },
    {
      text: '活动名称',
      name: 'name',
      type: 'text',
      rules: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
    }, {
      name: 'type',
      type: 'hidden',
    }, {
      names: ['beginTime', 'endTime'],
      text: '活动时间',
      type: 'daterange',
      rules: [{ required: true, message: '请输入活动时间', trigger: 'blur' }, { trigger: 'blur' }],
    }, {
      name: 'extra',
      items: [{
        name: 'operator',
        text: '责任人',
        type: 'member',
        rules: [{ required: true, message: '请输入责任人', trigger: 'blur' }],
      }],
    },
    {
      name: 'accountType',
      text: '活动用户类型',
      type: 'select',
      disabled: (vm, data) => !!data.values.lockAccountType,
      remote: true,
      option: {
        root: 'data',
        text: option => `${option.account_name}`,
        value: option => option.account_value,
        beforeRequest: () => ({
          url: '//act.woa.com/api/xy/f/prod/iwan_app/func/query',
          method: 'post',
          withCredentials: true,
          json: true,
          data: {
            appId: 'iwan_act_page_edit',
            schemaId: 'account_type',
            size: 'total',
          },
        }),
        afterRequest: (_, b) => b.data,
      },
      onChange: (vm, accountType) => vm.$store.dispatch('bact/updateAccountType', accountType),
    },
    {
      name: 'qps',
      text: 'QPS',
      type: 'hidden',
      defaultValue: 500,
      rules: [{ required: true, message: '请输入QPS', trigger: 'blur' },
        {
          validator({ value, callback }) {
            if (Number.isInteger(Number(value)) && Number(value) >= 100) {
              callback();
            } else {
              callback(new Error('必须大于100的整数'));
            }
          },
          trigger: 'blur',
        }],
      onChange: (vm, qps) => vm.$store.dispatch('bact/updateQPS', qps),
      extra: 'QPS计算方法：(每日PV / 43200) * 100，最小100',
    },
    {
      name: 'languageType',
      type: 'select',
      remote: true,
      valueKey: 'code',
      text: '语言类型',
      disabled: true,
      option: {
        url: '/v4/node/api?_a=getLangOptions&_c=common',
        root: 'data',
        body: {},
        text: 'text',
        value: 'value',
      },
    }, {
      name: 'regionType',
      type: 'select',
      text: '地区',
      disabled: true,
      remote: true,
      option: {
        url: '/v4/node/api?_a=getRegionList&_c=common',
        root: 'data',
        body: {},
        text: option => `${option.c_country_id}_${option.c_country_nm}`,
        value: option => `${option.c_country_id}`,
      },
    },
    {
      name: 'plugins',
      text: 'web插件',
      type: 'select',
      multiple: true,
      remote: true,
      option: {
        url: '/v4/node/api?_c=plugins&_a=getList',
        body: {
          platform: 'web-vue',
        },
        root: 'data',
        text: 'c_name',
        value: 'c_package',
      },
    },
    {
      name: 'more',
      type: 'app-more',
    }],
    // }, {
    //   name: 'hippyPlugins',
    //   text: 'hippy插件',
    //   type: 'select',
    //   multiple: true,
    //   remote: true,
    //   option: {
    //     url: '/v4/node/api?_c=plugins&_a=getList',
    //     body: {
    //       platform: 'hippy-vue',
    //     },
    //     root: 'data',
    //     text: 'c_name',
    //     value: 'c_package',
    //   },
    // }, {
    //   type: 'fieldset',
    //   text: 'ABTest',
    //   labelWidth: '100px',
    //   items: [{
    //     type: 'groupList',
    //     name: 'ABTest',
    //     defaultValue: [],
    //     row: [{
    //       text: '名称',
    //       name: 'name',
    //     }, {
    //       text: '分桶方式',
    //       name: 'type',
    //       type: 'select',
    //       options: [
    //         { text: 'vuid', value: 'vuid' },
    //         { text: 'pgv_pvid', value: 'pgv_pvid' },
    //       ],
    //     }, {
    //       type: 'table',
    //       name: 'pageList',
    //       defaultValue: [],
    //       columns: [{
    //         type: 'select',
    //         name: 'page',
    //         label: '页面',
    //         options: (vm) => {
    //           const { editor } = vm.mForm;
    //           const { uiApp } = editor.editorCore;
    //           return uiApp.appConfig.items.map(item => ({
    //             text: item.name,
    //             value: item.name,
    //           }));
    //         },
    //       }, {
    //         name: 'proportion',
    //         label: '比例',
    //         append: '%',
    //       }],
    //     }],
    //   }],
    // }, {
    //   name: 'boss',
    //   type: 'fieldset',
    //   text: '上报boss',
    //   labelWidth: '80px',
    //   items: [{
    //     filter: 'number',
    //     name: 'bossId',
    //     text: 'bossId',
    //   }, {
    //     filter: 'number',
    //     name: 'pwd',
    //     text: 'pwd',
    //   }, {
    //     filter: 'number',
    //     name: 'f_magic_appid',
    //     text: 'appId',
    //   }],
    // },
  }],
}];
